export default function SomethingWentWrong() {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>Something went wrong</h2>
        <p>Sorry, something went wrong, please try again later.</p>
        <img
            src="https://i.giphy.com/3o6ZtrFrmbFtt0Jvs4.webp"
            alt="Something went wrong GIF"
            style={{ width: '300px', height: '300px', margin: '20px' }}
        />
    </div>;
}